import { useEffect } from 'react';
import PropTypes from 'prop-types';
import { isCmsUi } from '@plone/volto/helpers/Url/Url';

// Tradução para Libras pelo VLibras, serviço do governo federal (gov.br).
// O script oficial tem cerca de 1 KB comprimido: ele mesmo põe o botão na
// borda direita da tela, num shadow DOM no fim do <body> (fora da árvore do
// React), e só baixa o avatar quando a pessoa clica. Carrega depois de a
// página terminar de carregar, para não disputar a banda do primeiro acesso.
// Nas telas de edição (editar, adicionar, conteúdos, painel de controle) o
// botão fica escondido: cobriria a barra lateral do Volto, que é à direita.

export const SCRIPT_VLIBRAS = 'https://vlibras.gov.br/app/vlibras-plugin.js';
const ID_SCRIPT = 'ag-vlibras';
// elementos que o próprio VLibras cria no <body>: o botão e, depois do clique, o avatar
const ELEMENTOS = ['vlibras-access-wrapper', 'vlibras-app-root'];

export const carregarVLibras = () => {
  if (document.getElementById(ID_SCRIPT)) return;
  const script = document.createElement('script');
  script.id = ID_SCRIPT;
  script.src = SCRIPT_VLIBRAS;
  script.async = true;
  document.body.appendChild(script);
};

const VLibras = ({ pathname }) => {
  const edicao = isCmsUi(pathname || '');

  useEffect(() => {
    if (edicao) return undefined;
    if (document.readyState === 'complete') {
      carregarVLibras();
      return undefined;
    }
    window.addEventListener('load', carregarVLibras, { once: true });
    return () => window.removeEventListener('load', carregarVLibras);
  }, [edicao]);

  useEffect(() => {
    ELEMENTOS.forEach((id) => {
      const elemento = document.getElementById(id);
      if (elemento) elemento.style.display = edicao ? 'none' : '';
    });
  }, [edicao]);

  return null;
};

VLibras.propTypes = {
  pathname: PropTypes.string,
};

export default VLibras;
